// extracted by mini-css-extract-plugin
module.exports = {"login":"forget_login__AB3SH"};